import { useMutation } from '@tanstack/react-query';
import { SessionsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useSessionsControllerRevokeSessionMutation(options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useMutation({
        mutationKey: ['sessionsControllerRevokeSession', accessControlScope],
        mutationFn: async (args) => {
            const api = new SessionsApi(accessControlConfig);
            return api.sessionsControllerRevokeSession(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useSessionsControllerRevokeSessionMutation.js.map